import React from 'react';
import { motion } from 'framer-motion';
import { Quote, Star } from 'lucide-react';
import { extendedTestimonials } from '../data/testimonials';
export function ExtendedTestimonials() {
  return <section className="py-24 px-4 bg-dark-card" data-id="element-55" data-mp="bjmfuaxnuwpf">
      <div className="max-w-6xl mx-auto" data-id="element-56" data-mp="bitj82sf1nl0">
        <div className="text-center mb-16" data-id="element-57" data-mp="gbe9iuc45ijs">
          <h2 className="text-3xl md:text-5xl font-serif font-bold" data-id="element-58" data-mp="gcfkkyt4q51i">Ce que disent les profs qui ont déjà leur système :</h2>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-59" data-mp="q90plk55fg5c">
          {extendedTestimonials.map((testimonial, index) => <motion.div key={testimonial.initials} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index % 3 * 0.1
        }} className={`bg-black border border-dark-border p-8 rounded-2xl relative ${index === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-60" data-mp="uadvfu88rjc9" data-mpi={index}>
              <Quote className="absolute top-6 right-6 text-gold/10" size={48} aria-hidden="true" data-id="element-61" data-mp="3ct8x54qopbh7" />
              <div className="flex gap-1 text-gold mb-6" aria-label="5 étoiles sur 5" data-id="element-62" data-mp="37yber77ilprn">
                {[...Array(5)].map((_, star) => <Star key={star} size={16} fill="currentColor" data-id="element-63" data-mp="2z09i13utdja6" data-mpi={star} />)}
              </div>
              <p className="text-gray-300 italic mb-8 relative z-10 leading-relaxed" data-id="element-64" data-mp="3vqif0hgd2gwc">&laquo;&nbsp;{testimonial.text}&nbsp;&raquo;</p>
              <div className="flex items-center gap-4 mt-auto" data-id="element-65" data-mp="3rowz0n8j5mhx">
                <div className="w-12 h-12 rounded-full bg-gold-gradient flex items-center justify-center text-black font-bold text-lg" data-id="element-66" data-mp="3mosodduazlzm">
                  {testimonial.initials}
                </div>
                <div data-id="element-67" data-mp="2baoppucrt9o8">
                  <div className="font-bold text-white" data-id="element-68" data-mp="2bayfphxtfgtx">{testimonial.name}</div>
                  <div className="text-xs text-gold-light" data-id="element-69" data-mp="26ast4g6ekkip">{testimonial.role}</div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}